<template>
  <div class="main-container">
    <HeaderLogin />
    <div class="container">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)" novalidate>
          <b-row class="mt-5 justify-content-center" align-v="center">
            <b-col md="4">
              <b-card title="Login">
                <validation-provider
                  name="Nome de utilizador"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group label="Nome de utilizador" label-for="username">
                    <b-form-input
                      id="username"
                      name="username"
                      v-model="login.username"
                      :state="validateState(validationContext)"
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Palavra-passe"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group label="Palavra-passe" label-for="password">
                    <b-form-input
                      id="password"
                      type="password"
                      name="password"
                      v-model="login.password"
                      :state="validateState(validationContext)"
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
                <div class="text-right">
                  <b-btn variant="success" type="submit">Iniciar sessão</b-btn>
                  <br><router-link class="text-sm"  :to="{name:'forgot_password'}">Esqueceu-se da palavra-passe?</router-link>
                </div>
                
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FooterFront />
  </div>
</template>


<script>
import HeaderLogin from "../../containers/Header_front.vue";
import FooterFront from "../../containers/Footer_front.vue";

export default {
  name: "LoginForm",
  data() {
    return {
      login: {
        username: "",
        password: "",
      },
      working: false,
    };
  },
  components: {
    HeaderLogin,
    FooterFront,
    // Header
  },
  methods: {
    onSubmit() {
      this.working = true;
      event.preventDefault();
      var redirect = this.$auth.redirect();
      var redirectTo = { name: "family" };
      if (redirect) {
        redirectTo = redirect.from;
      }
      this.$auth.login({
        data: {
          username: this.login.username,
          password: this.login.password,
        },
        redirect: redirectTo,
        success: function () {
          this.$bvToast.toast("Sessão inciada com sucesso", {
            autoHideDelay: 5000,
            variant: "success",
            solid: true,
          });
        },
        error: function () {
          this.working = false;
          this.$bvToast.toast(
            "Nome de utilizador ou palavra-passe incorrectos",
            { autoHideDelay: 5000, variant: "danger", solid: true }
          );
        },
      });
    },
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style>
body {
  background-color: #e4e5e6 !important;
}
</style>